export const germanCatalog = {
  'meta.title': 'Zug Bike Trails',
  'meta.description':
    'Interaktive Karte für Mountainbike-Routen und Veloverbindungen im Kanton Zug.',
  'app.label': 'Zug Bike Trails',
  'map.label': 'Karte',
  'map.status.notMounted': 'Karte wird in einem nächsten Migrationsschritt eingebunden.',
  'map.status.mounting': 'Karte wird vorbereitet.',
  'map.status.ready': 'Karte bereit.',
  'map.status.error': 'Karte konnte nicht geladen werden.',
  'branding.label': 'Projektpartner',
  'branding.trailStatus.label': 'ZugerbergTrail-Status',
  'branding.trailStatus.imageAlt': 'Aktueller ZugerbergTrail-Status',
  'branding.trailStatus.loading': 'Trail-Status wird geladen.',
  'branding.trailStatus.ready': 'Trail-Status geladen.',
  'branding.trailStatus.unavailable': 'Trail-Status ist derzeit nicht verfügbar.',
  'controls.label': 'Kartensteuerung',
  'controls.layers': 'Ebenen',
  'controls.information': 'Informationen',
  'controls.zoomIn': 'Vergrössern',
  'controls.zoomOut': 'Verkleinern',
  'controls.geolocate': 'Eigenen Standort anzeigen',
  'controls.basemap.pendingTitle': 'Die Hintergrundkarte folgt später',
  'panels.layers.label': 'Ebenen',
  'panels.layers.title': 'Ebenen',
  'panels.layers.pending': 'Die Ebenensteuerung wird in einem späteren Schritt aktiviert.',
  'panels.information.label': 'Informationen',
  'panels.languages.title': 'Sprache',
  'legend.difficulty.title': 'Trail-Schwierigkeit',
  'legend.difficulty.easy': 'Einfach',
  'legend.difficulty.professional': 'Profi',
  'legend.difficulty.moderate': 'Mittel',
  'legend.difficulty.gravel': 'Schotter',
  'legend.difficulty.expert': 'Experte',
  'legend.difficulty.road': 'Strasse',
  'legend.zugerwald.title': 'Zugerwald',
  'legend.zugerwald.bikeRoute': 'Bikeroute',
  'legend.zugerwald.forestRoad': 'Waldstrasse',
  'legend.publicTransport.title': 'ÖV',
  'legend.publicTransport.zugerbergbahn': 'Zugerbergbahn',
  'legend.plannedNotice':
    'Geplante Verbindungen sind schematische Suchlinien, keine Korridorflächen oder bewilligten Trassees.',
  'difficulty.easy': 'Leicht',
  'difficulty.medium': 'Mittel',
  'difficulty.difficult': 'Schwierig',
  'difficulty.veryDifficult': 'Sehr schwierig',
  'layers.bike-region': 'Bike Region',
  'layers.planned-bike-connections': 'Geplante Bike-Verbindungen',
  'layers.planned-cycling-connections': 'Geplante Veloverbindungen',
  'layers.bike-trails': 'Bike Trails',
  'layers.zugerwald-routes': 'Zugerwald Bikerouten',
  'layers.zugerbergbahn': 'Zugerbergbahn',
  'layers.recreation-network': 'Freizeitnetz',
  'layers.daily-network': 'Alltagsnetz',
  'layers.cycling-highway': 'Velobahn',
  'basemaps.swisstopo': 'Swisstopo',
  'basemaps.satellite': 'Satellit',
  'basemaps.streets': 'Strassenkarte',
  'basemaps.switchToSwisstopo': 'Zu Swisstopo wechseln',
  'basemaps.switchToSatellite': 'Zu Satellit wechseln',
  'basemaps.switchToStreets': 'Zu Strassenkarte wechseln',
  'terrain.enable': '3D-Ansicht aktivieren',
  'terrain.disable': '2D-Ansicht aktivieren',
  'sources.cantonalPlan': 'Richtplankarte',
  'sources.base': 'Grundlage',
  'sources.trailData': 'Traildaten',
  'sources.bikeRoutes': 'Bikerouten',
  'sources.bikeTransport': 'Bike-Transport',
  'sources.backgroundMap': 'Hintergrundkarte',
  'sources.zugerbergbahnRoute': 'Zugerbergbahn-Route',
  'sources.openStreetMapContributors': 'OpenStreetMap-Mitwirkende',
  'disclaimer.text':
    'Alle Angaben sind unverbindlich. Es gelten die jeweiligen gesetzlichen Bestimmungen vor Ort (Fahrverbote, Betretungsverbote etc.).',
  'popup.title': 'Trail-Informationen',
  'popup.status': 'Status',
  'popup.direction': 'Richtung',
  'popup.length': 'Länge',
  'popup.ascent': 'Aufstieg',
  'popup.descent': 'Abstieg',
  'popup.openTrailforks': 'Auf Trailforks öffnen',
  'popup.close': 'Trail-Informationen schliessen',
  'geolocation.requesting': 'Standort wird gesucht.',
  'geolocation.tracking': 'Standortverfolgung aktiv.',
  'geolocation.denied': 'Der Standortzugriff wurde abgelehnt.',
  'geolocation.timeout': 'Der Standort konnte nicht rechtzeitig bestimmt werden.',
  'geolocation.unsupported': 'Standortbestimmung wird von diesem Browser nicht unterstützt.',
  'geolocation.insecure': 'Standortbestimmung ist nur über eine sichere Verbindung verfügbar.',
  'geolocation.unavailable': 'Der Standort ist derzeit nicht verfügbar.',
  'errors.engineFatal': 'Die Karte ist nicht verfügbar.',
  'errors.basemapUnavailable': 'Die Hintergrundkarte ist nicht verfügbar.',
  'errors.layerUnavailable': 'Die Ebene {name} ist nicht verfügbar.',
  'errors.mapUnavailable': 'Ein Teil der Karte ist derzeit nicht verfügbar.',
  'errors.providerUnavailable': '{name} ist derzeit nicht verfügbar.',
  'errors.retry': 'Erneut versuchen',
  'errors.reload': 'Seite neu laden',
  'providers.analytics': 'Analytics',
  'providers.esri': 'Satellitenkarte',
  'providers.openfreemap': 'Strassenkarte',
  'providers.swisstopo': 'Swisstopo',
  'providers.terrain': '3D-Gelände',
  'providers.trailStatus': 'Trail-Status',
  'providers.zugerwald': 'Zugerwald-Ebenen',
  'live.layerShown': 'Ebene {name} eingeblendet.',
  'live.layerHidden': 'Ebene {name} ausgeblendet.',
  'live.basemapChanged': 'Hintergrundkarte zu {name} gewechselt.',
  'live.localeChanged': 'Sprache auf Deutsch geändert.',
  'live.trailSelected': 'Trail {name} ausgewählt.',
  'live.popupClosed': 'Trail-Informationen geschlossen.',
  'live.locationReceived': 'Standort empfangen.',
} as const;

export type MessageCatalog = Readonly<Record<keyof typeof germanCatalog, string>>;
export type MessageId = keyof typeof germanCatalog;

export const englishCatalog = {
  'meta.title': 'Zug Bike Trails',
  'meta.description':
    'Interactive map of mountain bike routes and cycling connections in the Canton of Zug.',
  'app.label': 'Zug Bike Trails',
  'map.label': 'Map',
  'map.status.notMounted': 'The map will be added in a later migration step.',
  'map.status.mounting': 'Preparing the map.',
  'map.status.ready': 'Map ready.',
  'map.status.error': 'The map could not be loaded.',
  'branding.label': 'Project partners',
  'branding.trailStatus.label': 'ZugerbergTrail status',
  'branding.trailStatus.imageAlt': 'Current ZugerbergTrail status',
  'branding.trailStatus.loading': 'Loading trail status.',
  'branding.trailStatus.ready': 'Trail status loaded.',
  'branding.trailStatus.unavailable': 'Trail status is currently unavailable.',
  'controls.label': 'Map controls',
  'controls.layers': 'Layers',
  'controls.information': 'Information',
  'controls.zoomIn': 'Zoom in',
  'controls.zoomOut': 'Zoom out',
  'controls.geolocate': 'Show my location',
  'controls.basemap.pendingTitle': 'The basemap will be added later',
  'panels.layers.label': 'Layers',
  'panels.layers.title': 'Layers',
  'panels.layers.pending': 'Layer controls will be enabled in a later step.',
  'panels.information.label': 'Information',
  'panels.languages.title': 'Language',
  'legend.difficulty.title': 'Trail difficulty',
  'legend.difficulty.easy': 'Easy',
  'legend.difficulty.professional': 'Professional',
  'legend.difficulty.moderate': 'Moderate',
  'legend.difficulty.gravel': 'Gravel',
  'legend.difficulty.expert': 'Expert',
  'legend.difficulty.road': 'Road',
  'legend.zugerwald.title': 'Zugerwald',
  'legend.zugerwald.bikeRoute': 'Bike route',
  'legend.zugerwald.forestRoad': 'Forest road',
  'legend.publicTransport.title': 'Public transport',
  'legend.publicTransport.zugerbergbahn': 'Zugerbergbahn',
  'legend.plannedNotice':
    'Planned connections are schematic search lines, not corridor areas or approved routes.',
  'difficulty.easy': 'Easy',
  'difficulty.medium': 'Moderate',
  'difficulty.difficult': 'Difficult',
  'difficulty.veryDifficult': 'Very difficult',
  'layers.bike-region': 'Bike Region',
  'layers.planned-bike-connections': 'Planned mountain bike connections',
  'layers.planned-cycling-connections': 'Planned cycling connections',
  'layers.bike-trails': 'Bike Trails',
  'layers.zugerwald-routes': 'Zugerwald mountain bike routes',
  'layers.zugerbergbahn': 'Zugerbergbahn',
  'layers.recreation-network': 'Recreational network',
  'layers.daily-network': 'Everyday network',
  'layers.cycling-highway': 'Cycle highway',
  'basemaps.swisstopo': 'Swisstopo',
  'basemaps.satellite': 'Satellite',
  'basemaps.streets': 'Street map',
  'basemaps.switchToSwisstopo': 'Switch to Swisstopo',
  'basemaps.switchToSatellite': 'Switch to satellite view',
  'basemaps.switchToStreets': 'Switch to the street map',
  'terrain.enable': 'Enable 3D view',
  'terrain.disable': 'Enable 2D view',
  'sources.cantonalPlan': 'Cantonal structure plan map',
  'sources.base': 'Base',
  'sources.trailData': 'Trail data',
  'sources.bikeRoutes': 'Bike routes',
  'sources.bikeTransport': 'Bike transport',
  'sources.backgroundMap': 'Background map',
  'sources.zugerbergbahnRoute': 'Zugerbergbahn route',
  'sources.openStreetMapContributors': 'OpenStreetMap contributors',
  'disclaimer.text':
    'All information is non-binding. The applicable local legal provisions apply (cycling prohibitions, access restrictions, etc.).',
  'popup.title': 'Trail information',
  'popup.status': 'Status',
  'popup.direction': 'Direction',
  'popup.length': 'Length',
  'popup.ascent': 'Ascent',
  'popup.descent': 'Descent',
  'popup.openTrailforks': 'Open in Trailforks',
  'popup.close': 'Close trail information',
  'geolocation.requesting': 'Finding your location.',
  'geolocation.tracking': 'Location tracking active.',
  'geolocation.denied': 'Location access was denied.',
  'geolocation.timeout': 'Your location could not be determined in time.',
  'geolocation.unsupported': 'Geolocation is not supported by this browser.',
  'geolocation.insecure': 'Geolocation requires a secure connection.',
  'geolocation.unavailable': 'Your location is currently unavailable.',
  'errors.engineFatal': 'The map is unavailable.',
  'errors.basemapUnavailable': 'The basemap is unavailable.',
  'errors.layerUnavailable': 'The {name} layer is unavailable.',
  'errors.mapUnavailable': 'Part of the map is currently unavailable.',
  'errors.providerUnavailable': '{name} is currently unavailable.',
  'errors.retry': 'Try again',
  'errors.reload': 'Reload page',
  'providers.analytics': 'Analytics',
  'providers.esri': 'Satellite map',
  'providers.openfreemap': 'Street map',
  'providers.swisstopo': 'Swisstopo',
  'providers.terrain': '3D terrain',
  'providers.trailStatus': 'Trail status',
  'providers.zugerwald': 'Zugerwald layers',
  'live.layerShown': '{name} layer shown.',
  'live.layerHidden': '{name} layer hidden.',
  'live.basemapChanged': 'Basemap changed to {name}.',
  'live.localeChanged': 'Language changed to English.',
  'live.trailSelected': '{name} trail selected.',
  'live.popupClosed': 'Trail information closed.',
  'live.locationReceived': 'Location received.',
} as const satisfies MessageCatalog;

export const frenchCatalog = {
  'meta.title': 'Zug Bike Trails',
  'meta.description':
    'Carte interactive des itinéraires VTT et des liaisons cyclables dans le canton de Zoug.',
  'app.label': 'Zug Bike Trails',
  'map.label': 'Carte',
  'map.status.notMounted': 'La carte sera intégrée lors d’une prochaine étape de migration.',
  'map.status.mounting': 'Préparation de la carte.',
  'map.status.ready': 'Carte prête.',
  'map.status.error': 'Impossible de charger la carte.',
  'branding.label': 'Partenaires du projet',
  'branding.trailStatus.label': 'Statut ZugerbergTrail',
  'branding.trailStatus.imageAlt': 'Statut actuel du ZugerbergTrail',
  'branding.trailStatus.loading': 'Chargement du statut du trail.',
  'branding.trailStatus.ready': 'Statut du trail chargé.',
  'branding.trailStatus.unavailable': 'Le statut du trail est actuellement indisponible.',
  'controls.label': 'Commandes de la carte',
  'controls.layers': 'Couches',
  'controls.information': 'Informations',
  'controls.zoomIn': 'Zoom avant',
  'controls.zoomOut': 'Zoom arrière',
  'controls.geolocate': 'Afficher ma position',
  'controls.basemap.pendingTitle': 'Le fond de carte sera ajouté ultérieurement',
  'panels.layers.label': 'Couches',
  'panels.layers.title': 'Couches',
  'panels.layers.pending': 'La commande des couches sera activée lors d’une prochaine étape.',
  'panels.information.label': 'Informations',
  'panels.languages.title': 'Langue',
  'legend.difficulty.title': 'Difficulté des trails',
  'legend.difficulty.easy': 'Facile',
  'legend.difficulty.professional': 'Pro',
  'legend.difficulty.moderate': 'Moyen',
  'legend.difficulty.gravel': 'Gravier',
  'legend.difficulty.expert': 'Expert',
  'legend.difficulty.road': 'Route',
  'legend.zugerwald.title': 'Zugerwald',
  'legend.zugerwald.bikeRoute': 'Itinéraire VTT',
  'legend.zugerwald.forestRoad': 'Route forestière',
  'legend.publicTransport.title': 'Transports publics',
  'legend.publicTransport.zugerbergbahn': 'Zugerbergbahn',
  'legend.plannedNotice':
    'Les liaisons planifiées sont des lignes de recherche schématiques, et non des corridors ou des tracés autorisés.',
  'difficulty.easy': 'Facile',
  'difficulty.medium': 'Moyen',
  'difficulty.difficult': 'Difficile',
  'difficulty.veryDifficult': 'Très difficile',
  'layers.bike-region': 'Région VTT',
  'layers.planned-bike-connections': 'Liaisons VTT planifiées',
  'layers.planned-cycling-connections': 'Liaisons cyclables planifiées',
  'layers.bike-trails': 'Trails VTT',
  'layers.zugerwald-routes': 'Itinéraires VTT de Zugerwald',
  'layers.zugerbergbahn': 'Zugerbergbahn',
  'layers.recreation-network': 'Réseau de loisirs',
  'layers.daily-network': 'Réseau quotidien',
  'layers.cycling-highway': 'Voie cyclable rapide',
  'basemaps.swisstopo': 'Swisstopo',
  'basemaps.satellite': 'Satellite',
  'basemaps.streets': 'Plan des rues',
  'basemaps.switchToSwisstopo': 'Passer à Swisstopo',
  'basemaps.switchToSatellite': 'Passer à la vue satellite',
  'basemaps.switchToStreets': 'Passer au plan des rues',
  'terrain.enable': 'Activer la vue 3D',
  'terrain.disable': 'Activer la vue 2D',
  'sources.cantonalPlan': 'Carte du plan directeur',
  'sources.base': 'Base',
  'sources.trailData': 'Données des trails',
  'sources.bikeRoutes': 'Itinéraires VTT',
  'sources.bikeTransport': 'Transport des vélos',
  'sources.backgroundMap': 'Fond de carte',
  'sources.zugerbergbahnRoute': 'Itinéraire Zugerbergbahn',
  'sources.openStreetMapContributors': 'Contributeurs OpenStreetMap',
  'disclaimer.text':
    'Toutes les informations sont non contraignantes. Les dispositions légales locales applicables prévalent (interdictions de circuler, restrictions d’accès, etc.).',
  'popup.title': 'Informations sur le trail',
  'popup.status': 'Statut',
  'popup.direction': 'Direction',
  'popup.length': 'Longueur',
  'popup.ascent': 'Montée',
  'popup.descent': 'Descente',
  'popup.openTrailforks': 'Ouvrir dans Trailforks',
  'popup.close': 'Fermer les informations sur le trail',
  'geolocation.requesting': 'Recherche de la position.',
  'geolocation.tracking': 'Suivi de la position actif.',
  'geolocation.denied': 'L’accès à la position a été refusé.',
  'geolocation.timeout': 'La position n’a pas pu être déterminée à temps.',
  'geolocation.unsupported': 'La géolocalisation n’est pas prise en charge par ce navigateur.',
  'geolocation.insecure': 'La géolocalisation nécessite une connexion sécurisée.',
  'geolocation.unavailable': 'La position est actuellement indisponible.',
  'errors.engineFatal': 'La carte est indisponible.',
  'errors.basemapUnavailable': 'Le fond de carte est indisponible.',
  'errors.layerUnavailable': 'La couche {name} est indisponible.',
  'errors.mapUnavailable': 'Une partie de la carte est actuellement indisponible.',
  'errors.providerUnavailable': '{name} est actuellement indisponible.',
  'errors.retry': 'Réessayer',
  'errors.reload': 'Recharger la page',
  'providers.analytics': 'Analytique',
  'providers.esri': 'Carte satellite',
  'providers.openfreemap': 'Plan des rues',
  'providers.swisstopo': 'Swisstopo',
  'providers.terrain': 'Terrain 3D',
  'providers.trailStatus': 'Statut du trail',
  'providers.zugerwald': 'Couches Zugerwald',
  'live.layerShown': 'Couche {name} affichée.',
  'live.layerHidden': 'Couche {name} masquée.',
  'live.basemapChanged': 'Fond de carte remplacé par {name}.',
  'live.localeChanged': 'Langue changée en français.',
  'live.trailSelected': 'Trail {name} sélectionné.',
  'live.popupClosed': 'Informations sur le trail fermées.',
  'live.locationReceived': 'Position reçue.',
} as const satisfies MessageCatalog;

export const italianCatalog = {
  'meta.title': 'Zug Bike Trails',
  'meta.description':
    'Mappa interattiva degli itinerari per mountain bike e dei collegamenti ciclabili nel Canton Zugo.',
  'app.label': 'Zug Bike Trails',
  'map.label': 'Mappa',
  'map.status.notMounted': 'La mappa sarà integrata in una prossima fase della migrazione.',
  'map.status.mounting': 'Preparazione della mappa.',
  'map.status.ready': 'Mappa pronta.',
  'map.status.error': 'Impossibile caricare la mappa.',
  'branding.label': 'Partner del progetto',
  'branding.trailStatus.label': 'Stato ZugerbergTrail',
  'branding.trailStatus.imageAlt': 'Stato attuale dello ZugerbergTrail',
  'branding.trailStatus.loading': 'Caricamento dello stato del trail.',
  'branding.trailStatus.ready': 'Stato del trail caricato.',
  'branding.trailStatus.unavailable': 'Lo stato del trail non è attualmente disponibile.',
  'controls.label': 'Comandi della mappa',
  'controls.layers': 'Livelli',
  'controls.information': 'Informazioni',
  'controls.zoomIn': 'Ingrandisci',
  'controls.zoomOut': 'Riduci',
  'controls.geolocate': 'Mostra la mia posizione',
  'controls.basemap.pendingTitle': 'La mappa di sfondo sarà aggiunta in seguito',
  'panels.layers.label': 'Livelli',
  'panels.layers.title': 'Livelli',
  'panels.layers.pending': 'Il comando dei livelli sarà attivato in una fase successiva.',
  'panels.information.label': 'Informazioni',
  'panels.languages.title': 'Lingua',
  'legend.difficulty.title': 'Difficoltà dei trail',
  'legend.difficulty.easy': 'Facile',
  'legend.difficulty.professional': 'Pro',
  'legend.difficulty.moderate': 'Media',
  'legend.difficulty.gravel': 'Ghiaia',
  'legend.difficulty.expert': 'Esperto',
  'legend.difficulty.road': 'Strada',
  'legend.zugerwald.title': 'Zugerwald',
  'legend.zugerwald.bikeRoute': 'Itinerario MTB',
  'legend.zugerwald.forestRoad': 'Strada forestale',
  'legend.publicTransport.title': 'Trasporto pubblico',
  'legend.publicTransport.zugerbergbahn': 'Zugerbergbahn',
  'legend.plannedNotice':
    'I collegamenti pianificati sono linee di ricerca schematiche, non corridoi o tracciati autorizzati.',
  'difficulty.easy': 'Facile',
  'difficulty.medium': 'Media',
  'difficulty.difficult': 'Difficile',
  'difficulty.veryDifficult': 'Molto difficile',
  'layers.bike-region': 'Regione MTB',
  'layers.planned-bike-connections': 'Collegamenti MTB pianificati',
  'layers.planned-cycling-connections': 'Collegamenti ciclabili pianificati',
  'layers.bike-trails': 'Trail MTB',
  'layers.zugerwald-routes': 'Itinerari MTB Zugerwald',
  'layers.zugerbergbahn': 'Zugerbergbahn',
  'layers.recreation-network': 'Rete per il tempo libero',
  'layers.daily-network': 'Rete quotidiana',
  'layers.cycling-highway': 'Ciclovia veloce',
  'basemaps.swisstopo': 'Swisstopo',
  'basemaps.satellite': 'Satellite',
  'basemaps.streets': 'Mappa stradale',
  'basemaps.switchToSwisstopo': 'Passa a Swisstopo',
  'basemaps.switchToSatellite': 'Passa alla vista satellitare',
  'basemaps.switchToStreets': 'Passa alla mappa stradale',
  'terrain.enable': 'Attiva la vista 3D',
  'terrain.disable': 'Attiva la vista 2D',
  'sources.cantonalPlan': 'Mappa del piano direttore',
  'sources.base': 'Base',
  'sources.trailData': 'Dati dei trail',
  'sources.bikeRoutes': 'Percorsi MTB',
  'sources.bikeTransport': 'Trasporto bici',
  'sources.backgroundMap': 'Mappa di sfondo',
  'sources.zugerbergbahnRoute': 'Percorso Zugerbergbahn',
  'sources.openStreetMapContributors': 'Collaboratori OpenStreetMap',
  'disclaimer.text':
    'Tutte le informazioni sono non vincolanti. Si applicano le disposizioni legali locali (divieti di circolazione, restrizioni di accesso, ecc.).',
  'popup.title': 'Informazioni sul trail',
  'popup.status': 'Stato',
  'popup.direction': 'Direzione',
  'popup.length': 'Lunghezza',
  'popup.ascent': 'Salita',
  'popup.descent': 'Discesa',
  'popup.openTrailforks': 'Apri in Trailforks',
  'popup.close': 'Chiudi le informazioni sul trail',
  'geolocation.requesting': 'Ricerca della posizione.',
  'geolocation.tracking': 'Tracciamento della posizione attivo.',
  'geolocation.denied': 'L’accesso alla posizione è stato negato.',
  'geolocation.timeout': 'Non è stato possibile determinare la posizione in tempo.',
  'geolocation.unsupported': 'La geolocalizzazione non è supportata da questo browser.',
  'geolocation.insecure': 'La geolocalizzazione richiede una connessione sicura.',
  'geolocation.unavailable': 'La posizione non è attualmente disponibile.',
  'errors.engineFatal': 'La mappa non è disponibile.',
  'errors.basemapUnavailable': 'La mappa di sfondo non è disponibile.',
  'errors.layerUnavailable': 'Il livello {name} non è disponibile.',
  'errors.mapUnavailable': 'Una parte della mappa non è attualmente disponibile.',
  'errors.providerUnavailable': '{name} non è attualmente disponibile.',
  'errors.retry': 'Riprova',
  'errors.reload': 'Ricarica la pagina',
  'providers.analytics': 'Analisi',
  'providers.esri': 'Mappa satellitare',
  'providers.openfreemap': 'Mappa stradale',
  'providers.swisstopo': 'Swisstopo',
  'providers.terrain': 'Terreno 3D',
  'providers.trailStatus': 'Stato del trail',
  'providers.zugerwald': 'Livelli Zugerwald',
  'live.layerShown': 'Livello {name} mostrato.',
  'live.layerHidden': 'Livello {name} nascosto.',
  'live.basemapChanged': 'Mappa di sfondo cambiata in {name}.',
  'live.localeChanged': 'Lingua cambiata in italiano.',
  'live.trailSelected': 'Trail {name} selezionato.',
  'live.popupClosed': 'Informazioni sul trail chiuse.',
  'live.locationReceived': 'Posizione ricevuta.',
} as const satisfies MessageCatalog;
